
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { signIn, signOut } from '../../auth/auth';
import { NotificationManager } from "Components/ReactNotifications";

import {
    LOGIN_USER,
    LOGOUT_USER
} from 'Constants/actionTypes';

import {
    loginUserSuccess
} from './actions';

const loginWithEmailPasswordAsync = async (email, password) =>
    await signIn(email, password)
        .then(authUser => authUser)
        .catch(error => error);



function* loginWithEmailPassword({ payload }) {
    const { email, password } = payload.user;
    const { history } = payload;
    const { form } = payload;
    try {
        const loginUser = yield call(loginWithEmailPasswordAsync, email, password);


        if (!loginUser.ERRORS.length) {
            console.log(loginUser);
            localStorage.setItem('user_id', loginUser.USER.UID);
            localStorage.setItem('user_hash', loginUser.USER.TOKEN);
            localStorage.setItem('user_nickname', loginUser.USER.NICKNAME);
            localStorage.setItem('user_name', loginUser.USER.NAME);
            localStorage.setItem('user_surname', loginUser.USER.SURNAME);
            localStorage.setItem('user_image', loginUser.USER.PICTURE);
            localStorage.setItem('user_can', loginUser.USER.CAN);

            yield put(loginUserSuccess(loginUser));
            history.push('/');
        } else {
            for (var i = 0; i < loginUser.ERRORS.length; i++) {
                setTimeout(function (err) {
                    NotificationManager.error(
                        err,
                        "خطای ورود به پلتفرم",
                        5000, null, null, "filled");
                }, (i + 1) * 500, loginUser.ERRORS[i]);

            }
            setTimeout(function (form) { form.setState({ isLoading: false }); }, 1000, form);
        }
    } catch (error) {
        // catch throw
        console.log('login error : ', error)
    }
}




const logoutAsync = async (history) => {
    await signOut(localStorage.getItem('user_id'), localStorage.getItem('user_hash')).then(authUser => authUser).catch(error => error);
    history.push('/')
}

function* logout({ payload }) {
    const { history } = payload
    try {
        yield call(logoutAsync, history);
        localStorage.removeItem('user_id');
        localStorage.clear();
    } catch (error) {
    }
}

export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}


export default function* rootSaga() {
    yield all([
        fork(watchLoginUser),
        fork(watchLogoutUser)
    ]);
}